import { useGetRecruitmentStatsQuery } from '@/app/features/recruitment/dashboard/recruitment-dashboard.api';
import { Clock01Icon, JobSearchIcon, UserIcon, UsersIcon } from '@/icons';
import { Card, Skeleton } from 'antd';

const STAT_CARDS = [
  {
    key: 'total_applicant_count' as const,
    icon: <UsersIcon size={32} className="text-gray-300" />,
    title: 'Total Applicants',
  },
  {
    key: 'total_current_stage_screening_count' as const,
    icon: <UserIcon size={32} className="text-gray-300" />,
    title: 'Screening',
  },
  {
    key: 'total_interview_status_in_progress_count' as const,
    icon: <Clock01Icon size={32} className="text-gray-300" />,
    title: 'Scheduled Interviews',
  },
  {
    key: 'active_job_post_count' as const,
    icon: <JobSearchIcon size={32} className="text-gray-300" />,
    title: 'Active Job Posts',
  },
];

export default function RecruitmentStates() {
  const { data, isLoading, isFetching } = useGetRecruitmentStatsQuery();

  const loading = isLoading || isFetching;
  const stats = data?.data?.data;

  return (
    <div className="flex justify-start overflow-x-auto hide-scrollbar md:grid md:grid-cols-2 gap-6">
      {STAT_CARDS.map((card) => (
        <Card
          key={card.key}
          className="dark:bg-theme-slate-800 border dark:border-theme-gray-700 rounded-xl text-white shadow-md"
          bodyStyle={{ padding: '22px' }}
        >
          <div className="flex flex-col gap-4 !w-52 md:!w-full">
            {/* Icon */}
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
              {card.icon}
            </div>

            {/* Value */}
            {loading ? (
              <Skeleton.Input active size="small" className="!w-20" />
            ) : (
              <div className="text-white text-2xl font-bold">
                {stats?.[card.key] ?? 0}
              </div>
            )}

            {/* Title */}
            <div className="text-white text-sm font-normal">{card.title}</div>
          </div>
        </Card>
      ))}
    </div>
  );
}
